var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "panel-competition-form-box",
    { staticClass: "mab8 register-input-item" },
    [
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "register-item" }, [
          _c("div", { staticClass: "register-item__content" }, [
            _c("div", { staticClass: "register-item__top" }, [
              _c("div", { staticClass: "register-item__main" }, [
                _vm.showsName
                  ? _c(
                      "div",
                      { staticClass: "mab16" },
                      [
                        _c("base-input-text", {
                          attrs: {
                            value: _vm.value.fNamePl,
                            hint: "Pytanie",
                            "without-error-message": "",
                            "is-short": "",
                          },
                          on: {
                            input: function ($event) {
                              return _vm.patch({ fNamePl: $event })
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.value.fType === "fi"
                  ? _c("div", { staticClass: "mab24 register-item__preview" }, [
                      _vm._v("Krótka odpowiedź"),
                    ])
                  : _vm.value.fType === "fj"
                  ? _c(
                      "div",
                      { staticClass: "mab24" },
                      [
                        _c("base-input-text", {
                          attrs: {
                            value: _vm.value.hint,
                            hint: "Podpowiedź",
                            "without-error-message": "",
                            "is-short": "",
                          },
                          on: {
                            input: function ($event) {
                              return _vm.patch({ hint: $event })
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm.value.fType === "fl"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "mab24 register-item__preview register-item__preview--tall",
                      },
                      [_vm._v(" Długa odpowiedź ")]
                    )
                  : _vm.value.fType === "fr"
                  ? _c(
                      "div",
                      { staticClass: "mab24" },
                      [
                        _vm._l(
                          _vm.value.options,
                          function (option, optionIndex) {
                            return _c(
                              "div",
                              {
                                key: `radio-${_vm.value._key}-${optionIndex}`,
                                staticClass: "register-item__option mab8",
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "register-item__option-mark" },
                                  [_c("i", { staticClass: "far fa-circle" })]
                                ),
                                _c("base-input-text", {
                                  staticClass: "register-item__option-field",
                                  attrs: {
                                    value: option,
                                    hint: "Odpowiedź",
                                    "without-error-message": "",
                                    "is-short": "",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.updateOption(
                                        optionIndex,
                                        $event
                                      )
                                    },
                                  },
                                }),
                                _vm.value.options.length > 1
                                  ? _c("base-button", {
                                      attrs: {
                                        btn2: "",
                                        short: "",
                                        icon: "fas fa-trash",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeOption(optionIndex)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          }
                        ),
                        _c(
                          "base-button",
                          {
                            staticClass: "mat8",
                            attrs: { btn2: "", short: "" },
                            on: { click: _vm.addOption },
                          },
                          [_vm._v("Dodaj odpowiedź")]
                        ),
                      ],
                      2
                    )
                  : _vm.value.fType === "fs"
                  ? _c(
                      "div",
                      { staticClass: "mab24" },
                      [
                        _vm._l(
                          _vm.value.options,
                          function (option, optionIndex) {
                            return _c(
                              "div",
                              {
                                key: `option-${_vm.value._key}-${optionIndex}`,
                                staticClass: "register-item__option mab8",
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "register-item__option-mark" },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-caret-down",
                                    }),
                                  ]
                                ),
                                _c("base-input-text", {
                                  staticClass: "register-item__option-field",
                                  attrs: {
                                    value: option,
                                    hint: "Odpowiedź",
                                    "without-error-message": "",
                                    "is-short": "",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.updateOption(
                                        optionIndex,
                                        $event
                                      )
                                    },
                                  },
                                }),
                                _vm.value.options.length > 1
                                  ? _c("base-button", {
                                      attrs: {
                                        btn2: "",
                                        short: "",
                                        icon: "fas fa-trash",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeOption(optionIndex)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          }
                        ),
                        _c(
                          "base-button",
                          {
                            staticClass: "mat8",
                            attrs: { btn2: "", short: "" },
                            on: { click: _vm.addOption },
                          },
                          [_vm._v("Dodaj odpowiedź")]
                        ),
                      ],
                      2
                    )
                  : _vm.value.fType === "fc"
                  ? _c(
                      "div",
                      { staticClass: "register-item__option mab24" },
                      [
                        _c(
                          "span",
                          { staticClass: "register-item__option-mark" },
                          [
                            _c("input", {
                              attrs: { type: "checkbox", disabled: "" },
                            }),
                          ]
                        ),
                        _c("base-input-text", {
                          staticClass: "register-item__option-field",
                          attrs: {
                            value: _vm.value.confirmation,
                            hint: "Potwierdzenie",
                            "without-error-message": "",
                            "is-short": "",
                          },
                          on: {
                            input: function ($event) {
                              return _vm.patch({ confirmation: $event })
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm.value.fType === "fh"
                  ? _c("div", { staticClass: "mab24 register-item__preview" }, [
                      _vm._v("Godzina"),
                    ])
                  : _vm.value.fType === "fd"
                  ? _c("div", { staticClass: "mab24 register-item__preview" }, [
                      _vm._v("Data"),
                    ])
                  : _vm.value.fType === "fa"
                  ? _c("div", { staticClass: "mab24 register-item__preview" }, [
                      _vm._v(" Paczkomat Inpost "),
                    ])
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "register-item__side" }, [
                _c("div", { staticClass: "mab16" }, [
                  _c(
                    "div",
                    { staticClass: "register-item__select" },
                    [
                      _c("v-select", {
                        attrs: {
                          value: _vm.value.fType,
                          options: _vm.typeOptions,
                          reduce: (item) => item.id,
                          clearable: false,
                          searchable: false,
                          label: "text",
                        },
                        on: { input: _vm.onTypeChange },
                        scopedSlots: _vm._u([
                          {
                            key: "option",
                            fn: function (option) {
                              return [
                                _c("i", {
                                  staticClass: "register-item__type-icon",
                                  class: option.icon,
                                }),
                                _c("span", [_vm._v(_vm._s(option.text))]),
                              ]
                            },
                          },
                          {
                            key: "selected-option",
                            fn: function (option) {
                              return [
                                _c("i", {
                                  staticClass: "register-item__type-icon",
                                  class: option.icon,
                                }),
                                _c("span", [_vm._v(_vm._s(option.text))]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ]),
                _vm.showsValidation
                  ? _c(
                      "div",
                      { staticClass: "mab16" },
                      [
                        _c("base-input-select", {
                          attrs: {
                            value: _vm.value.fValidation,
                            options: _vm.validationOptions,
                            reduce: (item) => item.id,
                            searchable: false,
                            clearable: false,
                            "is-panel": "",
                            "without-error-message": "",
                          },
                          on: {
                            input: function ($event) {
                              return _vm.patch({ fValidation: $event })
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]),
            _c("div", { staticClass: "register-item__footer" }, [
              _c(
                "div",
                {
                  staticClass:
                    "register-item__main register-item__main--actions",
                },
                [
                  _c("label", { staticClass: "register-item__required" }, [
                    _c("input", {
                      attrs: { type: "checkbox" },
                      domProps: { checked: _vm.value.fRequired },
                      on: {
                        change: function ($event) {
                          return _vm.patch({ fRequired: $event.target.checked })
                        },
                      },
                    }),
                    _vm._v(" Wymagana odpowiedź "),
                  ]),
                  _c(
                    "base-button",
                    {
                      attrs: { btn2: "", short: "", icon: "fas fa-trash" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("remove", _vm.index)
                        },
                      },
                    },
                    [_vm._v(" Usuń ")]
                  ),
                  _c(
                    "base-button",
                    {
                      attrs: { btn2: "", short: "", icon: "fas fa-clone" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("copy", _vm.index)
                        },
                      },
                    },
                    [_vm._v(" Powiel ")]
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "register-item__side" }, [
                _c(
                  "div",
                  { staticClass: "register-item__classifications" },
                  [
                    _c(
                      "multiselect",
                      {
                        attrs: {
                          value: _vm.selectedClassifications,
                          options: _vm.classifications,
                          label: "namePl",
                          "track-by": "id",
                          multiple: true,
                          searchable: false,
                          "close-on-select": false,
                          "show-labels": false,
                          "hide-selected": false,
                          placeholder: "Pytanie widoczne dla...",
                        },
                        on: { input: _vm.onClassificationsChange },
                        scopedSlots: _vm._u([
                          {
                            key: "tag",
                            fn: function ({ option }) {
                              return [
                                _c("span", { staticClass: "custom__tag" }, [
                                  _vm._v(_vm._s(option.namePl) + ", "),
                                ]),
                              ]
                            },
                          },
                        ]),
                      },
                      [
                        _c("template", { slot: "caret" }, [
                          _vm.selectedClassifications.length > 0
                            ? _c("span", { staticClass: "caret-count" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.selectedClassifications.length) +
                                    " "
                                ),
                              ])
                            : _c("div", { staticClass: "multiselect__select" }),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "register-item__reorder" }, [
            _c(
              "button",
              {
                staticClass: "register-item__reorder-btn",
                attrs: {
                  type: "button",
                  disabled: _vm.index === 0,
                  title: "W górę",
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("move-up", _vm.index)
                  },
                },
              },
              [_c("i", { staticClass: "fas fa-angle-double-up" })]
            ),
            _c(
              "button",
              {
                staticClass: "register-item__reorder-btn",
                attrs: {
                  type: "button",
                  disabled: _vm.index >= _vm.total - 1,
                  title: "W dół",
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("move-down", _vm.index)
                  },
                },
              },
              [_c("i", { staticClass: "fas fa-angle-double-down" })]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }